module.exports = __webpack_public_path__ + "media/images/bg-body-e5783cb0905755a88e4de03452174139.jpg";